import script from "./BlogsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogsList.vue?vue&type=script&setup=true&lang=ts"

import "./BlogsList.vue?vue&type=style&index=0&id=48da1c10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48da1c10"]])

export default __exports__